import { footerLinks } from "@/mocks/dramaData";

export default function Footer() {
  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-background-100 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.6fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex cursor-pointer items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-brand text-2xl leading-none text-foreground-950">本月大瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注聚合盘点本月娱乐圈与公众关注的热门事件，以总览、榜单、分类与时间轴帮你看清每个月的大瓜全貌。
            </p>
            <a
              href="#contact"
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              投稿 / 订阅瓜报
              <i className="ri-mail-send-line"></i>
            </a>
          </div>

          {Object.entries(footerLinks).map(([group, links]) => (
            <nav key={group} aria-label={group}>
              <h4 className="font-heading text-sm font-black text-foreground-950">{group}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="cursor-pointer text-sm text-foreground-600 transition hover:text-primary-700">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 本月大瓜 · 文娱热点盘点平台。内容为演示聚合信息，仅供浏览参考。
          </p>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-500">订阅入口</span>
            <button
              onClick={goTop}
              aria-label="返回顶部"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-arrow-up-line"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}